import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules';

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isLoading: false,
        count: 0,
        login: false,
        loginShow: false,
        token: "11",
        userInfo: {},
        pageNoScroll: false,//页面不能滚动
        m_id: '',
        id: '',
        pageBackFlag: '',
        customList: [],
        customBackgroundColor:'',
        memberMenuValue:0,
        loginRegister: '',
        homeTitle:'',
        pageType: '',
        privateMask:false,//临时  购票二维码
        tokenInfo: '',
        userInfoCon: {},
    },
    mutations: {
        tokenInfo: (state, info) => {
          state.tokenInfo = info;
        },
        removeTokenInfo: (state) => {
          state.tokenInfo = null;
          localStorage.removeItem('xjsc_login_access_token_2019_3_7');
        },
        userInfoCon: (state, info) => {
          state.userInfoCon = info;
        },
        removeUserInfoCon: (state) => {
          state.userInfoCon = null;
          localStorage.removeItem('user_info_20201231');
        },
        setPageNoScrollMutations:(state, flag) =>{
            state.pageNoScroll = flag
        },
        setTokenMutations:(state, token) =>{
            state.token = token
        },
        add:(state, n)=>{
            state.count += n
        },
        loaddingChange:(state, flag) =>{
            state.isLoading = flag
        },
        loginStatus:(state, flag) =>{
            state.login = flag
        },
        loginShowStatus:(state, flag) =>{
            state.loginShow = flag
        },
        userInfoUpdate:(state, flag) =>{
            state.userInfo = flag
        },
        //自定义需要的数据
        getPageBackFlag: (state, data) => {
            state.pageBackFlag = data;
        },
        getCustomList: (state, data) => {
            state.customList = data;
        },
        getCustomBackgroundColor: (state, data) => {
            state.customBackgroundColor = data;
        },
        updataMemberMenu:(state, data) => {
            state.memberMenuValue = data;
        },
        getHomeTitle: (state, data) => {
            state.homeTitle = data;
        },
        getPageType: (state, data) => {
            state.pageType = data;
        },
        getMid: (state, data) => {
            state.m_id = data;
        },
        getPrivateMask: (state, data) => {
            state.privateMask = data;
        }
    },
    getters: {
        count(state) {
            state.count += 100
            return state.count
        },
        tokenInfo(state) {
            if (!state.tokenInfo || (state.tokenInfo && !Object.keys(state.tokenInfo).length)) {
                state.tokenInfo = localStorage.getItem('xjsc_login_access_token_2019_3_7');
            }
            return state.tokenInfo;
        },
        userInfoCon(state) {
            if (!state.userInfoCon || (state.userInfoCon && !Object.keys(state.userInfoCon).length)) {
               state.userInfoCon = JSON.parse(localStorage.getItem('user_info_20201231'));
            }
            return state.userInfoCon;
        },
    },
    actions: {
        setTokenInfo({ commit }, info) {
            localStorage.setItem('xjsc_login_access_token_2019_3_7', info);
            commit('tokenInfo', info);
        },
        userInfoCon({ commit }, info) {
            localStorage.setItem('user_info_20201231', JSON.stringify(info));
            commit('userInfoCon', info);
        },
        setPageNoScroll({ commit }, flag) {
            commit('setPageNoScrollMutations', flag)
        },
        loaddingChangeAction({ commit }, flag) {
            commit('loaddingChange', flag)
        },
        addAction(context) {
            console.log("1231312")
            context.commit('add', 10)
        },
        setTokenAction({ commit }, token) {
            alert(token)
            commit('setTokenMutations', token)
        },
        updateLogin({ commit }, flag) {
            commit('loginStatus', flag)
        },
        updateLoginShow({ commit }, flag) {
            commit('loginShowStatus', flag)
        },
        updateUserInfo({ commit }, flag) {
            commit('userInfoUpdate', flag)
        },
        //自定义页需要的数据
        pageBackFlag({ commit }, data) {
            commit('getPageBackFlag', data)
        },
        customList({ commit }, data) {
            commit('getCustomList', data)
        },
        customBackgroundColor({ commit }, data) {
            commit('getCustomBackgroundColor', data)
        },
        updataMemberMenu({ commit }, data) {
            commit('updataMemberMenu', data)
        },
        homeTitle({ commit }, data) {
            commit('getHomeTitle', data)
        },
        pageType({ commit }, data) {
            commit('getPageType', data)
        },
        setMid({ commit }, data) {
            commit('getMid', data)
        },
        setPrivateMask({ commit }, data) {
            commit('getPrivateMask', data)
        },
    },
    modules,
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js